// extracted by css-extract-rspack-plugin
export default {"list":"SpecifiedWorkSummaries__list--sgPey","listItem":"SpecifiedWorkSummaries__listItem--SuxKF","item":"SpecifiedWorkSummaries__item--DG0py"};